import Atividade from './Atividade';

export default Atividade;